/**
 * Convert time string (HH:MM or HH:MM:SS, any hour digit count) to minutes since midnight.
 * Handles both formats from form inputs (HH:MM) and database (HH:MM:SS).
 */
export function timeStringToMinutes(time: string): number {
  if (!time) return 0;
  const parts = time.split(':').map(Number);
  const hours = parts[0] ?? 0;
  const minutes = parts[1] ?? 0;
  const seconds = parts[2] ?? 0;
  return hours * 60 + minutes + Math.round(seconds / 60);
}

/**
 * Check if two time ranges overlap. Uses strict less-than so that
 * back-to-back lessons (one ends exactly when another starts) are NOT
 * considered overlapping.
 *
 * @param start1 - Start of first range (HH:MM or HH:MM:SS)
 * @param end1 - End of first range (HH:MM or HH:MM:SS)
 * @param start2 - Start of second range (HH:MM or HH:MM:SS)
 * @param end2 - End of second range (HH:MM or HH:MM:SS)
 * @returns true if ranges share any moment in time (strict: touching at boundary = no overlap)
 */
export function doTimesOverlap(
  start1: string,
  end1: string,
  start2: string,
  end2: string
): boolean {
  const s1 = timeStringToMinutes(start1);
  const e1 = timeStringToMinutes(end1);
  const s2 = timeStringToMinutes(start2);
  const e2 = timeStringToMinutes(end2);
  // Overlap exists when one range starts before the other ends.
  // Strict < ensures same end/start time = no overlap (back-to-back allowed).
  return s1 < e2 && s2 < e1;
}
